/*
  InboxRequests.js - InboxRequests Networking Module

  Contains networking functionality for Inbox Component
*/

// UTILS
import RequestRabbit from './RequestRabbit';

// CONFIG
import config from '../Config';

const useInboxRequest = () => {
  /**
   * Fetches inbox data within a date range.
   */
  const getInbox = async (fromDate, toDate, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/sms/replies/?from_date=${fromDate}&to_date=${toDate}&type=SMS`;
      const options = { method: 'GET' };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      if (response?.status > 399 && response?.status < 600) {
        errorHandler(responseJSON.error);
        return [];
      }
      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return [];
    }
  };

  /**
   * Searches inbox items based on the provided criteria.
   */
  const searchInboxItems = async (searchObject, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/sms/replies/`;
      const headers = new Headers({ 'Content-Type': 'application/json' });
      const options = {
        method: 'POST',
        body: JSON.stringify(searchObject) || null,
        headers,
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      if (response?.status > 399 && response?.status < 600) {
        errorHandler(responseJSON.error);
        return [];
      }
      return responseJSON;
    } catch (e) {
      errorHandler(e);
      return [];
    }
  };

  /**
   * Fetches data for a single inbox reply.
   */
  const getInboxReply = async (replyId, isEmailReply, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/sms/replies/${replyId}?isEmailReply=${isEmailReply}`;
      const options = { method: 'GET' };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      if (response?.status > 399 && response?.status < 600) {
        errorHandler(responseJSON.error);
        return [];
      }
      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
      return [];
    }
  };

  const requestExportInboxMessages = async (searchObject, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/sms/replies/export`;
      const headers = { 'Content-Type': 'application/json' };
      const options = {
        method: 'POST',
        body: JSON.stringify(searchObject),
        headers: headers,
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      return await response.text();
    } catch (e) {
      errorHandler(e.message);
    }
  };

  // Export functions as a module
  return {
    getInbox,
    searchInboxItems,
    getInboxReply,
    requestExportInboxMessages,
  };
};

export default useInboxRequest;
